import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class DigitalDeskService {

  constructor(private ws: PostmethodService) { }

  getLeadSource(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardLeadSourceFilter");
  }

  getGeography(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardgeogrphicalFilter");
  }

  getStatus(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCombineFilter");
  }

  getProduct(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardProductFilter");
  }

  getZoneCardCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/ddZoneCount");
  }

  getZoneCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardCount");
  }

  getStageCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/ddDashboardCount");
  }

  getAssignCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/ddDashboardAssignedCount");
  }

  getGeographyChartCounts(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardGeographyCount");
  }

  getDealersAndOutlets(request:any){
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/dashboardParentOutletFilter");
  }

  getParentDealerChartCount(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/DashboardParentDealerCount");
  }

  getRegionalMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/regionalManagerFilter");
  }

  getAreaMgrs(request: any) {
    return this.ws.wsPost(request, environment.loginUrl + "/dashboard/areaManagerFilter");
  }

}
